/* eslint-disable no-underscore-dangle */
import {
  Component, EventEmitter, Input, OnInit, Output, ViewChild
} from '@angular/core';
import { UntypedFormGroup, AbstractControl, UntypedFormBuilder } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';

import { FormsFieldsState, ModifierTypes, SvgIconSizeMod } from 'models/layout-mod.model';
import { BaseComponent } from 'shared/base/base.component';
import { StylingService } from 'shared/services/styling.service';

@Component({
  selector: 'app-input-tags',
  templateUrl: './input-tags.component.html',
  styleUrls: ['./input-tags.component.scss']
})
export class InputTagsComponent<T> extends BaseComponent implements OnInit {
  @ViewChild('select') select!: NgSelectComponent;

  @Output() onAdd = new EventEmitter<any>();

  @Output() onRemove = new EventEmitter();

  @Output() onClear = new EventEmitter<string>();

  @Input() options!: T[];

  @Input() defaultValue!: string[];

  @Input() mainForm!: UntypedFormGroup;

  @Input() controlName!: string;

  @Input() labelKey = 'title';

  @Input() valueKey = 'value';

  @Input() disabledKey!: string;

  @Input() searchable?: boolean = false;

  @Input() clearable?: boolean = false;

  @Input() clearOnBackspace?: boolean = true;

  @Input() placeholder?: string = '';

  @Input() clearAllLabel?: string = '';

  @Input() maxSelectedItems?: number;

  @Input() state?: FormsFieldsState;

  @Input() layoutMod: ModifierTypes[] = [];

  layoutModifier = '';

  control!: AbstractControl | null;

  _options: T[] = [];

  constructor(
    protected fb: UntypedFormBuilder,
    private stylingService: StylingService
  ) { super(); }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.control = this.mainForm.controls[this.controlName];
    this.layoutModifier = this.stylingService.concatLayoutModifiers('dropdown', this.layoutMod);

    if (this.defaultValue && this.control && !this.control.value) {
      this.control.setValue(this.defaultValue, {
        emitEvent: false,
        onlySelf: true
      });
    }

  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  onAddEvent(value: string): void {
    if (this.control) {
      const controlValue: string[] = this.control.value || [];
      const valuesList = value.replace(/[;,]/g, ',').split(",");

      for (let i = 0; i < valuesList.length; ++i) {
        const value = valuesList[i].trim();
        if (!controlValue.includes(value)) {
          controlValue.push(value);
        }
      }

      this.control.setValue(controlValue, {
        emitEvent: false,
        onlySelf: true
      });

    }
  }

  onFocusOutEvent(event: any): void {
    if (event.target.value && event.target.value !== '') {
      this.onAddEvent(event.target.value);
      event.target.value = '';
    }
  }


  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  onRemoveEvent(event: any): void {
    this.onRemove.emit(event);
  }

  onClearEvent(): void {
    this.onClear.emit(this.controlName);
  }

  protected readonly svgIconSizeMod = SvgIconSizeMod;
}
